(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .controller('sgElementActivityCtrl', sgElementActivityCtrl);

  sgElementActivityCtrl.$inject = ['$scope', 'Labels'];

  function sgElementActivityCtrl ($scope, Labels) {
    $scope.labels = Labels;
    $scope.tabs = {
      all: Labels.getPluralCapFirstLetter('all'),
      comments: Labels.getPluralCapFirstLetter('comment'),
      history: Labels.getLabelCapFirstLetter('history')
    };

    $scope.filterItems = function (key) {
      if (!$scope.logs) {
        return [];
      }

      return $scope.logs.filter(function (log) {
        if (key === 'all') {
          return true;
        } else if (key === 'comments') {
          return log.type === 'COMMENT';
        } else if (key === 'history') {
          return log.type === 'CREATED' || log.type === 'CHANGE';
        }
        return false;
      });
    };
  }

})();
